import { Record } from "immutable";

/**
 * @type {Object}
 */
const MentionSuggestionRecord = Record({
  editorMention: null,
  originalDataFromSource: null,
});

export default class MentionSuggestion extends MentionSuggestionRecord {
  /**
   * @returns {EditorMention}
   */
  getEditorMention() {
    return this.get("editorMention");
  }

  /**
   * @returns {String}
   */
  getMentionType() {
    return this.get("editorMention").get("type");
  }

  /**
   * @returns {EditorMention}
   */
  getOriginalData() {
    return this.get("originalDataFromSource");
  }

  /**
   * @param {EditorMention} editorMention
   * @param {*}             originalDataFromSource
   */
  static wrap(editorMention, originalDataFromSource) {
    return new MentionSuggestion({
      editorMention,
      originalDataFromSource,
    });
  }
}
